"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _BaseSeoManager2 = _interopRequireDefault(require("../BaseSeoManager"));

var _CasaOldHelmetDataHelper = require("../helpers/CasaOldHelmetDataHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MANAGER_TYPE = _SeoManagerHelpers.HELPER_MANAGER_TYPE.OLD;
var TR_DECODE = {
  en: {
    buy: 'buy',
    rent: 'rent'
  },
  fr: {
    vente: 'buy',
    location: 'rent'
  },
  de: {
    kaufen: 'buy',
    mieten: 'rent'
  },
  it: {
    vendita: 'buy',
    vendite: 'buy',
    affitti: 'rent',
    affitto: 'rent'
  }
};
var CAT_DECODED = {
  it: {
    residenziale: 'residenziale',
    commerciale: 'commerciale',
    vacanze: 'vacanze',
    vacanza: 'vacanze'
  }
};
var PROVENCE_ALPES_COTE_AZUR = {
  '01': '01',
  '02': '02',
  '03': '03',
  '04': '04',
  '05': '05',
  '06': '06',
  '07': '07',
  'alpes-maritimes': '01',
  herault: '02',
  'alpes-h-provence': '03',
  'haute-savoie': '04',
  ain: '05',
  corsica: '06',
  "var": '07'
};

var CasaOldSeoManager = /*#__PURE__*/function (_BaseSeoManager) {
  _inherits(CasaOldSeoManager, _BaseSeoManager);

  var _super = _createSuper(CasaOldSeoManager);

  function CasaOldSeoManager(domain, lang) {
    var _this;

    _classCallCheck(this, CasaOldSeoManager);

    _this = _super.call(this, domain, lang);
    _this.encode_parts = {};
    _this.encode_qs = [];
    _this.locations = [];
    _this.num_levels = 0;
    _this.max_levels = 0;
    _this.min_levels = 2;
    _this.level_prec = null;
    return _this;
  }

  _createClass(CasaOldSeoManager, [{
    key: "decodeLevel",
    value: function decodeLevel(level, value, levels) {
      // TRY TO AVOID EVERY DECODE FOR OLD SEOMANAGER URLS
      return;
    }
  }, {
    key: "decode",
    value: function decode(url) {
      return _get(_getPrototypeOf(CasaOldSeoManager.prototype), "decode", this).call(this, url, MANAGER_TYPE);
    }
  }], [{
    key: "getLevel1Slug",
    value: function getLevel1Slug() {
      return {
        type: MANAGER_TYPE,
        regexp: /(vendita|vendite|affitti|affitto)-(residenziale|commerciale|vacanze|vacanza)/,
        isRegExp: true
      };
    }
  }]);

  return CasaOldSeoManager;
}(_BaseSeoManager2["default"]);

var _default = CasaOldSeoManager;
exports["default"] = _default;